export const getModalTitle = (requestId: number | undefined): string => {
  if (!requestId) {
    return '';
  }

  const title = `Approval History - Request no. ${requestId}`;
  return title;
};

export const getDescription = (action: string, occupation: string): string => {
  const output = `${action}  ${occupation ? `by ${occupation}` : ''}`;
  return output;
};
